module.exports = __webpack_public_path__ + "static/img/company-logo.56e5d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/001-U-Map-images/company-logo.png
// module id = gp+m
// module chunks = 1